import { RecipientsActionTypes, RecipientsMutationTypes } from './types';
import { notifySuccess, notifyError, notifyDefaultError } from '../../helpers/notifications';

export const actions = {
    async [RecipientsActionTypes.GetRecipients]({ commit }, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.getRecipients.get({
                params: { ...params },
            }).then((response) => {
                if(response && response.data) {
                    commit(`${RecipientsMutationTypes.SetRecipients}`, { recipients: response.data.data })
                    resolve(response.data)
                }
            })
            .catch((error) => {
                notifyDefaultError({ error })
                reject(error)
            })
        })
    },
    async [RecipientsActionTypes.AddRecipient](context, { data } = {}) {
        const recipient_data = data
        return new Promise((resolve, reject) => {
            this.$api.addRecipient.post({
                body: { ...recipient_data }
            })
            .then((response) => {
                const body = response && response.data
                if (body && body.error_message) {
                    notifyError({ title: body.error_message, errors: body.errors })
                    reject(body)
                    return
                }
                if (body && body.data) {
                    notifySuccess({ title: body.message })
                    resolve(body)
                    return
                }
                notifyDefaultError({ error: 'Не удалось добавить получателя' })
                reject(body)
            })
            .catch(error => {
                notifyDefaultError({ error })
                reject(error)
            })
        })           
    },
    async [RecipientsActionTypes.SetRecipientPromotion]({ commit }, { id, promotion }) {
        const response = await this.$api.editRecipient.update({ id, body: { promotion } })
        const body = response && response.data
        if (body && body.error_message) {
            notifyError({ title: body.error_message, errors: body.errors })
            throw new Error(body.error_message)
        }
        if (body && body.data) {
            commit(RecipientsMutationTypes.SetChangedRecipient, { recipient: body.data })
            notifySuccess({ title: body.message })
            return body
        }
        notifyDefaultError({ error: 'Не удалось сохранить акцию' })
        throw new Error('promotion')
    },
    async [RecipientsActionTypes.SetRecipientGroup]({ commit }, { id, group }) {
        const response = await this.$api.editRecipient.update({ id, body: { group } })
        const body = response && response.data
        if (body && body.error_message) {
            notifyError({ title: body.error_message, errors: body.errors })
            throw new Error(body.error_message)
        }
        if (body && body.data) {
            commit(RecipientsMutationTypes.SetChangedRecipient, { recipient: body.data })
            notifySuccess({ title: body.message })
            return body
        }
        notifyDefaultError({ error: 'Не удалось сохранить станцию' })
        throw new Error('group')
    },
    async [RecipientsActionTypes.EditRecipient]({ commit }, { id, value }) {
        try {
            const response = await this.$api.editRecipient.patch({ id, body: {
                ...value
            } })
            if (response && response.data) {
                commit(RecipientsMutationTypes.SetChangedRecipient, {recipient: response.data.data})
                notifySuccess({ title: response.data.message })
            }
        } catch (error) {
            notifyDefaultError({ error })
        }
    },
    async [RecipientsActionTypes.AddRecipientProfile]({ commit }, { value }) {
        try {
            const response = await this.$api.addRecipientProfile.post({ body: { ...value } });
            if (response && response.data) {
                if (response.data.data) {
                    commit(RecipientsMutationTypes.SetChangedRecipient, { recipient: response.data.data });
                }
                notifySuccess({ title: response.data.message });
            }
        } catch (error) {
            notifyDefaultError({ error });
        }
    },
    async [RecipientsActionTypes.EditRecipientProfile]({ commit }, { id, value }) {
        try {
            const response = await this.$api.editRecipientProfile.patch({ id, body: { ...value } });
            if (response && response.data) {
                if (response.data.data) {
                    commit(RecipientsMutationTypes.SetChangedRecipient, { recipient: response.data.data });
                }
                notifySuccess({ title: response.data.message });
            }
        } catch (error) {
            notifyDefaultError({ error });
        }
    },
    async [RecipientsActionTypes.DeleteRecipient]({ commit }, { id }) {
        try {
            const response = await this.$api.deleteRecipient.delete({ 
                body: { id: id } 
            })
            if (response && response.data) {
                commit(RecipientsMutationTypes.SetDeletedRecipient, { id })
                notifySuccess({ title: response.data.message })
            }
        } catch (error) {
            notifyDefaultError({ error })
        }
    },
    async [RecipientsActionTypes.FindRecipient]({ commit }, { search, params }) {
        return new Promise((resolve, reject) => {
            this.$api.findRecipient.get({
                params: { search, ...params },
            }).then((response) => {
                if (response && response.data) {
                    commit(`${RecipientsMutationTypes.SetRecipients}`, { recipients: response.data.data })
                    resolve(response.data)
                }
            })
            .catch((error) => {
                notifyDefaultError({ error })
                reject(error)
            })
        })
    },
}